import { FC } from 'react';
import { formLayoutRightPanelStickyStyles } from './FormLayout.styles';
import Box from 'yoda-ui/components/Box';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

const FormLayoutRightPanel: FC = ({ children }) => {
  return (
    <Box
      display="flex"
      marginLeft={ YodaSpacing.large }
      sx={ formLayoutRightPanelStickyStyles }
    >
      { children }
    </Box>
  );
};

export default FormLayoutRightPanel;
